Vue.filter('isShowAddToBasket', function (properties) {
  if (!properties) {
    return true;
  }
  let result = true;
  properties.forEach(function (props) {
    if (props && props.properties) {
      props.properties.forEach(function (prop) {
        if (prop.id == 19 || (prop.id == 3 && prop.values.value == '1')) {
          result = false;
        }
      });
    }
  });
  return result;
});
